import { ChatMergeMode } from 'utils/chat/chatConstants';

const getChatMessageCount = (chat) => {
    return typeof chat?.total_message_count === 'number' ? chat.total_message_count : (chat?.messages || []).length;
};

export const getChatMessagesVersion = (chat) => {
    return typeof chat?.messages_version === 'number' ? chat.messages_version : (chat?.messages || []).length;
};

export const upsertMessagesById = (messages = [], incomingMessages = []) => {
    const messageById = new Map();
    const messagesWithoutId = [];

    [...messages, ...incomingMessages].forEach((message) => {
        if (!message?.id) {
            messagesWithoutId.push(message);
            return;
        }

        const existingMessage = messageById.get(message.id);
        if (!existingMessage || (message.modified_on || 0) >= (existingMessage.modified_on || 0)) {
            messageById.set(message.id, message);
        }
    });

    return [...messageById.values(), ...messagesWithoutId];
};

export const appendPersistedMessage = (chat, message) => {
    if (!chat) return chat;
    if ((chat.messages || []).some(({ id }) => id === message.id)) return chat;

    return {
        ...chat,
        modified_on: message.modified_on,
        messages_version: getChatMessagesVersion(chat) + 1,
        total_message_count: getChatMessageCount(chat) + 1,
        messages: [...(chat.messages || []), message],
    };
};

export const mergePersistedMessage = (chat, message) => {
    if (!chat) return chat;

    const messages = chat.messages || [];
    const existingMessageIndex = messages.findIndex(({ id }) => id === message.id);
    const nextMessages = upsertMessagesById(messages, [message]);
    const messageCountDelta = existingMessageIndex < 0 ? 1 : 0;

    return {
        ...chat,
        modified_on: message.modified_on || chat.modified_on,
        messages_version: messageCountDelta > 0 ? getChatMessagesVersion(chat) + 1 : getChatMessagesVersion(chat),
        total_message_count: getChatMessageCount(chat) + messageCountDelta,
        messages: nextMessages,
    };
};

export const mergeFetchedChatPage = ({ currentChat, nextChat, mode = ChatMergeMode.REPLACE }) => {
    if (!nextChat) return currentChat;
    if (mode !== ChatMergeMode.PREPEND || !currentChat) return nextChat;

    return {
        ...nextChat,
        messages: upsertMessagesById(nextChat.messages || [], currentChat.messages || []),
    };
};

export const hasOlderChatMessages = (chat) => {
    return Boolean(chat?.has_more_messages && chat?.next_before_message_id);
};

export const buildChatReconciliationPayload = (chat) => {
    if (!chat?.id) return {};

    return {
        chat_reconciliations: [
            {
                chat_id: chat.id,
                messages_version: getChatMessagesVersion(chat),
            },
        ],
    };
};
